/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionsTransactionOut } from './TransactionsTransactionOut';
import {
    TransactionsTransactionOutFromJSON,
    TransactionsTransactionOutFromJSONTyped,
    TransactionsTransactionOutToJSON,
} from './TransactionsTransactionOut';

/**
 * 
 * @export
 * @interface GetMoneyOutTransDetailsOutput
 */
export interface GetMoneyOutTransDetailsOutput {
    /**
     * 
     * @type {TransactionsTransactionOut}
     * @memberof GetMoneyOutTransDetailsOutput
     */
    transactions?: TransactionsTransactionOut;
    /**
     * 
     * @type {Error}
     * @memberof GetMoneyOutTransDetailsOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the GetMoneyOutTransDetailsOutput interface.
 */
export function instanceOfGetMoneyOutTransDetailsOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetMoneyOutTransDetailsOutputFromJSON(json: any): GetMoneyOutTransDetailsOutput {
    return GetMoneyOutTransDetailsOutputFromJSONTyped(json, false);
}

export function GetMoneyOutTransDetailsOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMoneyOutTransDetailsOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': !exists(json, 'transactions') ? undefined : TransactionsTransactionOutFromJSON(json['transactions']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function GetMoneyOutTransDetailsOutputToJSON(value?: GetMoneyOutTransDetailsOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': TransactionsTransactionOutToJSON(value.transactions),
        'error': value.error,
    };
}

